import axios from "axios";
import * as paths from "../constants/paths";

export default axios.create({
  baseURL: paths.API_OPENSEARCH_URL,
  headers: {
    "Content-type": "multipart/form-data"
  }
});
